import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrollIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Enroll",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.65 20.95h-3.16V6.06c0-1.76-1.42-3.18-3.17-3.18H5.8A4.06 4.06 0 0 0 2 6.93v2.73c0 .75.61 1.36 1.36 1.36h4.07v14.02c0 1.16.48 2.21 1.26 2.95.72.69 1.71 1.12 2.79 1.12h14.45c2.25 0 4.07-1.82 4.07-4.07V22.3c0-.75-.6-1.35-1.35-1.36ZM22.33 5.59c.25 0 .46.2.46.46v14.9H14.2c-.75 0-1.36.61-1.36 1.36v2.65c0 .65-.41 1.2-.98 1.41s-.31 0-.31 0h-.05c-.37 0-.7-.14-.95-.37a1.32 1.32 0 0 1-.42-.97V6.96c0-.27-.03-.54-.08-.79v.03q0-.13-.05-.24c-.06-.11-.05-.24-.09-.36h12.43ZM4.71 8.3V6.83c0-.75.61-1.36 1.36-1.36s1.36.61 1.36 1.36v1.46H4.72ZM27.3 25.02c0 .75-.61 1.36-1.36 1.36H15.32c.14-.4.23-.86.23-1.34v-1.37H27.3zM13.29 10.11h6.32c.7-.06 1.24-.65 1.24-1.35s-.54-1.29-1.24-1.35h-6.45c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h.12Zm0 4.52h6.32c.7-.06 1.24-.65 1.24-1.35s-.54-1.29-1.24-1.35h-6.45c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h.12Zm0 4.53h6.32c.7-.06 1.24-.65 1.24-1.35s-.54-1.29-1.24-1.35h-6.45c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h.12Z"
    })
  }));
};